import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Col, Row } from 'reactstrap';
import styled from 'styled-components';
import dayjs from 'dayjs';

import LikertQuestionChoice from './LikertQuesitonChoice';
import { feedbackDraftState } from './feedbackDraftState';

const InnerCircle = styled.div`
  height: 30px;
  width: 30px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border: 2px solid ${(props) => props.borderColor};
  border-radius: 50%;
  display: inline-block;
  font-weight: 700;
`;

const wrapperStyle = {
  width: '20%',
  width: '20%',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
};

const LikertQuestion = ({
  question,
  draftKey,
  Answers4QuestionsAnswerNumberScore,
  updateEval,
  i,
  checkIfStatusNeedsChangingToModify,
  questionOptions,
  numberOfSelections = 5,
  demo,
  questionaireDisabled,
}) => {
  const [selected, setSelected] = useState(null);
  const [saveError, setSaveError] = useState('');
  const intentVersionRef = useRef(0);
  const isMountedRef = useRef(false);
  const currentQuestionRef = useRef(null);
  currentQuestionRef.current = { question, questionOptions, draftKey };
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const [likertLengthAlphabet, setLikertLengthAlphabet] = useState([]);
  const [gridTemplateColumns, setGridTemplateColumns] = useState('');
  const [answer, setAnswer] = useState(null);

  const [windowWidth, setWindowWidth] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);

  let isMobile = windowHeight > windowWidth;
  useEffect(() => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);

    document.addEventListener('mousemove', () => {
      const now = dayjs();
      localStorage.setItem('lastActivity', now.format('MMM DD, YYYY hh:mm A'));
    });
    document.addEventListener('click', () => {
      const now = dayjs();
      localStorage.setItem('lastActivity', now.format('MMM DD, YYYY hh:mm A'));
    });

    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    });
  }, []);

  useEffect(() => {
    const draft = feedbackDraftState.getDraft(draftKey);
    if (draft?.kind === 'scale') {
      setSelected(questionOptions.findIndex((item) => Number(item.DisplayValue) === Number(draft.value)));
      return;
    }
    const acknowledgedIndex = question.pk_EvaluationAnswer && question.AnswerNumber != null
      ? questionOptions.findIndex((item) => Number(question.AnswerNumber) === Number(item.DisplayValue))
      : -1;
    setSelected(acknowledgedIndex >= 0 ? acknowledgedIndex : null);
  }, [question, draftKey, questionOptions]);

  useEffect(() => {
    // set the grid width based on the number of choices
    if (numberOfSelections === 5) {
      setGridTemplateColumns('20% 20% 20% 20% 20%');
    }

    if (numberOfSelections === 4) {
      setGridTemplateColumns('25% 25% 25% 25%');
    }

    if (numberOfSelections === 3) {
      setGridTemplateColumns('33.33% 33.33% 33.33%');
    }
    const alphabetArray = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm'];

    //
    const restrictedArray = alphabetArray.splice(0, numberOfSelections);
    setLikertLengthAlphabet(restrictedArray);
  }, [numberOfSelections]);

  const postAnswer = async (DisplayValue, pk_EvaluationQuestion) => {
    if (!demo) {
      const intentVersion = ++intentVersionRef.current;
      setSaveError('');
      const result = await updateEval(DisplayValue, pk_EvaluationQuestion, 'scale');
      if (!isMountedRef.current || intentVersion !== intentVersionRef.current) {
        return;
      }
      const current = currentQuestionRef.current;
      if (result?.capacity && !feedbackDraftState.getDraft(current.draftKey)) {
        // Admission was refused before retaining this choice. Restore the current
        // acknowledged value, never an earlier captured selection or another intent.
        const acknowledgedIndex = current.question.pk_EvaluationAnswer && current.question.AnswerNumber != null
          ? current.questionOptions.findIndex((item) => Number(item.DisplayValue) === Number(current.question.AnswerNumber))
          : -1;
        setSelected(acknowledgedIndex >= 0 ? acknowledgedIndex : null);
        setSaveError('Recovery limit reached. Score change was not accepted. Save retained feedback before trying again.');
      }
    }
  };

  const constructCircleClassName = (num) => {
    return 'light-blue-border-hover ' + (selected === num ? 'selectedButton' : '');
  };

  const { pk_EvaluationQuestion } = question;

  return (
    <Row>
      <Col style={{ padding: 0 }} lg="12" md="12">
        <p style={{ fontWeight: 700 }}>
          <span style={{ fontWeight: 700 }}>{i + 1}. </span>
          {question.EnableRequired && <span style={{ color: '#ff0000' }}>*</span>}
          {question.QuestionText}
        </p>
      </Col>
      {saveError && <Col lg="12" md="12"><div role="alert">{saveError}</div></Col>}
      <Col lg="12" md="12" style={{ maxWidth: '100%', padding: 5 }}>
        <div
          className="like-wrapper"
          style={{ display: 'flex', justifyContent: 'space-evenly', flexDirection: 'row', flexWrap: 'wrap' }}
        >
          {questionOptions &&
            questionOptions.map((item, index) => {
              return (
                <>
                  <div
                    style={{
                      padding: 5,
                      marginBottom: 0,
                      width: isMobile ? 80 : '10%',
                    }}
                  >
                    <LikertQuestionChoice
                      item={item}
                      index={index}
                      postAnswer={postAnswer}
                      checkIfStatusNeedsChangingToModify={checkIfStatusNeedsChangingToModify}
                      setSelected={setSelected}
                      pk_EvaluationQuestion={pk_EvaluationQuestion}
                      constructCircleClassName={constructCircleClassName}
                      selected={selected}
                      questionaireDisabled={questionaireDisabled}
                      isMobile={isMobile}
                    />
                  </div>
                </>
              );
            })}
        </div>
      </Col>
    </Row>
  );
};

export default LikertQuestion;
